// extracted by mini-css-extract-plugin
export default {"infoIcon":"box_tooltip-module___infoIcon___ee3f5ac2"};